import { render, staticRenderFns } from "./TciNewsDiv.vue?vue&type=template&id=27fb8171"
import script from "./TciNewsDiv.vue?vue&type=script&lang=js"
export * from "./TciNewsDiv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports